import {BlueLinkButton} from '@/ui/app'
import {ArrowTopRightIcon} from '@sanity/icons'
import {Box, Flex, Heading, Stack, Text} from '@sanity/ui'
import React from 'react'

interface AgentActionSettingsProps {
  // Stub for adding props in the future
}

export const AgentActionSettings: React.FC<AgentActionSettingsProps> = () => {
  return (
    <Stack space={4}>
      <Box paddingTop={2}>
        <Heading size={2} as="h2">
          Agent Actions
        </Heading>
      </Box>
      <Box>
        <Text size={2} muted as="p" style={{maxWidth: 600}}>
          Agent actions lets you programatically run schema-aware AI instructions to create and
          modify Sanity documents. You can run instructions from anywhere you can execute code, such
          as Sanity Functions, custom components, webhook listeners, CI/CD pipelines, migratinos
          scripts, and more.
        </Text>
      </Box>
      <Flex>
        <Box paddingTop={3} style={{marginLeft: '-0.75rem'}}>
          <BlueLinkButton
            icon={ArrowTopRightIcon}
            href={`https://www.sanity.io/docs/agent-actions`}
            fontSize={1}
            target={'_blank'}
            text={'Learn more about Agent Actions in Sanity Docs'}
            mode="bleed"
          />
        </Box>
      </Flex>
    </Stack>
  )
}
